var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import Collapse from 'syf-component-library/ui/atoms/Collapse';
import { Inline } from 'syf-component-library/ui/spacing';
import { StyledButton } from './subcomponents';
import { getButtonAnalytics } from '../../../helpers/getAnalytics';
import { Routes } from '../../../const';
var CollapseAccordion = function (_a) {
    var children = _a.children, title = _a.title, collapseId = _a.collapseId;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = getButtonAnalytics(Routes.PLAN_REVIEW), dataType = _c.dataType, dataObject = _c.dataObject, dataAnalytics = _c.dataAnalytics;
    return (_jsxs(_Fragment, { children: [_jsxs(StyledButton, __assign({ buttonType: "ghost", onClick: function () { return setIsOpen(!isOpen); }, "data-type": dataType, "data-object": dataObject, "data-analytics": dataAnalytics, "data-reason": title }, { children: [title, _jsx(Inline, { size: "small" }), _jsx(FontAwesomeIcon, { icon: (isOpen ? faAngleUp : faAngleDown) })] })), _jsx(Collapse, __assign({ id: collapseId, expand: isOpen }, { children: children }))] }));
};
export default CollapseAccordion;
//# sourceMappingURL=index.js.map